module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Darkest-Minds-The.2a775d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Darkest-Minds-The.jpg
// module id = 4kdM
// module chunks = 0